import classNames from 'classnames';
import { FaArrowTrendDown, FaArrowTrendUp } from 'react-icons/fa6';
import { toNumberString } from '@client/toolkit';

export const ChangePercentage = ({
  value,
  size = 'sm',
  isInverted,
}: {
  value: number;
  size?: 'sm' | '2xl' | '3xl';
  isInverted?: boolean;
}) => {
  const direction = value === 0 ? 'neutral' : value > 0 ? 'up' : 'down';
  const formattedValue = toNumberString(value);
  const valueString = direction === 'up' ? `+${formattedValue}%` : `${formattedValue}%`;
  return (
    <span
      className={classNames(
        'flex items-baseline gap-1',
        isInverted
          ? direction === 'up'
            ? 'text-negative'
            : 'text-positive'
          : direction === 'up'
            ? 'text-positive'
            : 'text-negative',
        direction === 'neutral' && 'text-white',
        `text-${size}`,
      )}
    >
      {value !== 0 ? direction === 'up' ? <FaArrowTrendUp /> : <FaArrowTrendDown /> : null}
      <span>{valueString}</span>
    </span>
  );
};
